import { Component, OnInit, Host } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { CamerasService } from "./cameras.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { CamerasMainComponent } from "./cameras.main.component";
import { CameraApiServiceListResponseDTO } from "./cameras.service.dto";

@Component({
    selector: "app-cameras",
    templateUrl: "./cameras.component.html",
    styleUrls: ["cameras.component.scss"],
    standalone: false
})
export class CamerasComponent extends BaseMaterialDatatableComponent<CameraApiServiceListResponseDTO> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: CameraApiServiceListResponseDTO[] = [];

    constructor(
        private camerasService: CamerasService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: CamerasMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: camerasService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_cameras_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["unverifiedBackofficeRegisteredCamera", "imei", "name", "productType", "user", "created", "updated", "actions"],
            listService: camerasService
        });

        this.UTCDATEFORMAT = this.camerasService.UTCDATEFORMAT;
    }

    // _dataTableTrigger() {
    //     return (dataTableParameters: DataTableParameters, callback: Function) => {
    //         // get api query parameters by datatable
    //         const queryParams = this.getApiQueryParamsByDataTable(dataTableParameters);

    //         this.subscriptions.push(
    //             this.camerasService.cameras(queryParams).subscribe((result) => {
    //                 this.rows = result.list;

    //                 callback({
    //                     recordsTotal: result.total,
    //                     recordsFiltered: result.count,
    //                     data: []
    //                 });
    //             })
    //         );
    //     };
    // }

    addCamera() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editCamera(type?: string, id?: string) {
        this.router.navigate([type, id], { relativeTo: this.route });
    }

    deleteCamera(type?: string, id?: string) {
        const initialState = {
            title: this.translateService.instant("cameras.list.delete.title"),
            message: this.translateService.instant("cameras.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        if (bsModalRef.content) {
            bsModalRef.content.confirmCallback = () => {
                if (!type || !id) {
                    return;
                }

                this.subscriptions.push(
                    this.camerasService.deletecamera({ type, id }).subscribe((result) => {
                        this.alertService.addSuccess(this.translateService.instant("cameras.list.delete.success"));
                        this.loadData();
                    })
                );
            };
        }
    }
}
